import { graphql } from '@api/generated';
import { useQuery } from '@apollo/client';

export const GET_CUSTOMER_INFORMATION = graphql(`
  query getCustomerInformation($tenantId: ID!, $customerId: ID!) {
    customer(tenantId: $tenantId, id: $customerId) {
      type
      lifetimeRevenue
      outstandingBalance
      membership
    }
  }
`);

export const useCustomerInformation = (
  tenantId: string,
  customerId?: string,
) => {
  const skip = !customerId;
  const { data, loading, error, refetch } = useQuery(GET_CUSTOMER_INFORMATION, {
    fetchPolicy: 'network-only',
    variables: skip ? undefined : { tenantId, customerId },
    notifyOnNetworkStatusChange: true,
    skip,
  });

  return { customerInformation: data?.customer, loading, error, refetch };
};
